<template>
  <section class="content-wrapper h-100 information-wrapper">
    <b-modal v-model="editSkills.showModal" size="md" :style="{ zIndex: 200 }" :modal-class="isModalLoading ? 'loading' : ''" no-close-on-backdrop centered>
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">Update skills</h5>
        <button type="button" aria-label="Close" class="close" @click.prevent="cancel">
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <div>
        <div class="table_theme-info">
          <b-table class="mb-0 pb-0" :items="userSkills" :fields="fieldsSkill" fixed>
            <template v-slot:cell(value)="data">
              <b-form>
                <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="skill_value[data.item.id]">
                  <multiselect v-model="skill_value[data.item.id]" :options="skillScale" :allow-empty="false"
                    :showLabels="false" :class="{ 'multiselect__single-line': true }" />
                </div>
              </b-form>
            </template>
            <template v-slot:cell(Actions)="data">
              <div class="d-flex">
                <b-button variant="secondary" class="button btn-icon" @click="editSkill(data.item.id)">
                  <span v-html="editIconSvg"></span>
                </b-button>
                <b-button v-if="$can('delete-skills') || $can('delete_own-skills')" variant="secondary"
                  class="button btn-icon ml-1" @click="detachSkill($event, data.item.id)">
                  <span v-html="removeIconSvg"></span>
                </b-button>
              </div>
            </template>
          </b-table>
          <table class="table b-table b-table-fixed mb-0">
            <tbody>
              <tr>
                <td>
                  <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="newSkill.skill ? newSkill.skill.name : null">
                    <multiselect v-model="newSkill.skill" :options="skills" :allow-empty="false" :showLabels="false"
                      label="name" track-by="id" :class="{ 'multiselect__single-line': true }" />
                  </div>
                </td>
                <td>
                  <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="newSkill.scale">
                    <multiselect v-model="newSkill.scale" :options="skillScale" :allow-empty="false"
                      :showLabels="false" :class="{ 'multiselect__single-line': true }" />
                  </div>
                </td>
                <td class="actions-column">
                  <b-button variant="secondary" class="button btn-icon" @click="addSkill">
                    <span class="material-symbols-outlined">
                      save
                    </span>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" class="button" @click.prevent="cancel">
          Close
        </b-button>
      </template>
    </b-modal>

    <div v-if="$can('read_all-skills') || $can('read_own-skills')">
      <div class="user-skills__header">
        <div class="user-skills__title">Skills</div>
        <b-button variant="secondary" class="button" v-if="isMyProfile ? $can('update_own-users') : $can('update_all-users')"
          @click.prevent="setVisibleEditSkillsModal(true)">
          Update skills
        </b-button>
      </div>
      <div class="user-skills__body">
        <div class="user-skills__list">
          <div v-for="skill in userSkills" :key="skill.id">
            <div class="user-skills-chips">
              <span>{{ skill.name }}</span>
              <span class="material-symbols-outlined material-symbols-fill-1 mr-1 ml-2 icon-size">
                star
              </span>
              <span>{{ skill.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import starIcon from '@/assets/star.svg'
import editIcon from '@/assets/icons/editIcon'
import removeIcon from '@/assets/icons/removeIcon'

export default {
  name: 'UserSkills',
  props: {
    isUserProfile: {
      type: Boolean,
      default: false
    },
    isMyProfile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      starIcon,
      editIconSvg: editIcon(),
      removeIconSvg: removeIcon(),
      editSkills: {
        showModal: false
      },
      loading: false,
      isModalLoading: false,
      userId: null,
      skill_value: [],

      userSkills: [],
      skills: [],

      skill: [],
      form: {
        user_id: '',
        skill_id: 0,
        skill_value: 1
      },
      fieldsSkill: [
        {
          label: 'Name',
          key: 'name'
        },
        {
          label: 'Assessment',
          key: 'value'
        },
        {
          label: 'Actions',
          key: 'Actions',
          class: 'actions-column'
        }
      ],
      skillScale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      newSkill: {
        skill: null,
        scale: 1
      }
    }
  },
  computed: {
    userType () {
      return this.isUserProfile ? 'user-profile' : 'user'
    }
  },
  methods: {
    setVisibleEditSkillsModal (status) {
      this.editSkills.showModal = status
    },
    editSkill (skillId) {
      this.form.user_id = this.userId
      this.form.skill_id = skillId
      this.form.skill_value = this.skill_value[skillId]
      this.attachSkill('updated')
    },
    detachSkill (e, skillId) {
      this.isModalLoading = true
      this.axios.post(
        `/api/skill/detach`,
        {
          user_id: this.userId,
          skill_id: skillId,
          user_type: this.userType
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(() => {
          this.cleatForm()
          this.userSkills = this.userSkills.filter(item => item.id !== skillId)
          this.$snotify.success('Skill successfully deleted', 'Success', this.$store.state.snotify)
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.isModalLoading = false
        })
    },
    addSkill () {
      if (!this.newSkill.skill) {
        return this.$snotify.error('Skill is empty', 'Error', this.$store.state.snotify)
      }

      this.form.user_id = this.userId
      this.form.skill_id = this.newSkill.skill.id
      this.form.skill_value = this.newSkill.scale

      this.attachSkill('added')
    },
    clearNewSkill () {
      this.newSkill = {
        skill: null,
        scale: 1
      }
    },
    async attachSkill (action) {
      this.isModalLoading = true
      this.axios.post(
        `/api/skill/attach`,
        {
          ...this.form,
          user_type: this.userType
        },
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(async (response) => {
        if (response.status === 200) {
          this.$snotify.success('Skill successfully ' + action, 'Success', this.$store.state.snotify)
        }
        await this.getUserSkillsForModal()
        this.cleatForm()
        this.clearNewSkill()
      }).catch(err => {
        this.errorNotifications(err)
      }).finally(() => {
        this.isModalLoading = false
      })
    },
    async getSkills () {
      await this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.skills = response.data
      }).catch(err => {
        this.errorNotifications(err)
      })
    },
    async getUserSkills () {
      this.loading = true

      await this.axios({
        method: 'get',
        url: this.isUserProfile ? `/api/skills/user_profiles/${this.userId}` : `/api/skills/user/${this.userId}`,
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.userSkills = response.data
        // this.editProfile.form.skills.value = this.userSkills
        var arrayValue = []
        this.userSkills.forEach(function (skill) {
          arrayValue[skill.id] = skill.value
        })
        this.skill_value = arrayValue
      }).catch(err => {
        this.errorNotifications(err)
      }).finally(() => {
        this.loading = false
      })
    },
    async getUserSkillsForModal () {
      await this.axios({
        method: 'get',
        url: this.isUserProfile ? `/api/skills/user_profiles/${this.userId}` : `/api/skills/user/${this.userId}`,
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.userSkills = response.data
        // this.editProfile.form.skills.value = this.userSkills
        var arrayValue = []
        this.userSkills.forEach(function (skill) {
          arrayValue[skill.id] = skill.value
        })
        this.skill_value = arrayValue
      }).catch(err => {
        this.errorNotifications(err)
      })
    },
    cleatForm () {
      this.form = {
        user_id: '',
        skill_id: 0,
        skill_value: 1
      }
      this.skill = []
    }
  },
  async mounted () {
    if (this.$route.params.id === undefined) {
      this.userId = this._UserInfo.id
    } else {
      this.userId = this.$route.params.id
    }
    await this.getUserSkills()
    await this.getSkills()
  }
}
</script>

<style>
.icon-size {
  font-size: 12px;
}
</style>
